//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateImageURL } from '~/utils/storage'
import { formatNumber } from '~/utils/formatter'

export default {
  name: 'RewardCardItem',
  props: {
    reward: { type: Object, default: () => ({}) },
  },
  methods: {
    generateImage(url) {
      return `${generateImageURL(url || '')}?&fit=crop`
    },
    formattedNumber(value) {
      return `${formatNumber(value)}`
    },
  },
}
